<template>
  <div>
    <slot />
  </div>
</template>

<script>
import flatMap from "lodash/flatMap";
import cloneDeep from "lodash/cloneDeep";

import { findFiltersAndMakeThemToReactiveFilters } from "@/components/base_components/tables/services/reactive-filter-service";

export default {
  name: "WorkDialogSearchFilterWrapper",
  model: {
    prop: 'filter'
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
  },
  methods: {
    _emitInput(key, event) {
      this.filter[key] = event;
      this.$emit('input', cloneDeep(this.filter));
    },
    _processSlots() {
      let slots = flatMap(this.$slots.default);
      let references = [...slots];
      findFiltersAndMakeThemToReactiveFilters(references, this.filter, this._emitInput);
    },
  },
  created() {
    this._processSlots();
  },
  beforeUpdate() {
    this._processSlots();
  },
}
</script>